export async function postResultToServer(result) {
    try {
        let url = '/api/postResult';
        let bodyStripped = result.toJS();
        console.log(JSON.stringify(bodyStripped));
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(bodyStripped)
        });
        if (!response.ok) {
            let responseText = await response.text();
            throw new Error(response.statusText + ' ' + responseText);
        }
        return response.json();
    } catch (error) {
        throw new Error('Kunde inte spara resultatet! ' + error.message);
    }
}


// WEBPACK FOOTER //
// ./src/services/backendClient.js